<template>
  <cardTemplate
    :classCustom="'overall margin-bottom-10'"
    v-if="dataVanThu && dataVanThu.length"
  >
    <template #content>
      <div
        class="header flex-row flex__between padding-bottom-10 has-border__bottom"
      >
        <div class="leftSection">
          <div class="tt theTitle theTitle__lv1"></div>
        </div>
        <div class="rightSection flex-row flex__right">
          <div class="tt theTitle">Chờ tiếp nhận</div>
          <div class="tt theTitle">Chờ xử lý</div>
          <div class="tt theTitle">Chờ ban hành</div>
          <div class="tt theTitle">Đã ban hành</div>
        </div>
      </div>
      <div class="body margin-bottom-10">
        <div
          v-for="item in dataVanThu"
          :key="item.userDeptRoleView.positionId"
          class="item-info flex-row flex__between has-border__bottom"
        >
          <div class="leftSection">
            <div
              class="theTitle theTitle__lv1"
              style="width: 100%; max-width: 100%"
              :title="
                item &&
                item.userDeptRoleView &&
                item.userDeptRoleView.positionName +
                  ' ' +
                  item.userDeptRoleView.deptName
              "
            >
              {{
                item &&
                item.userDeptRoleView &&
                item.userDeptRoleView.positionName +
                  " " +
                  item.userDeptRoleView.deptName
              }}
            </div>
          </div>
          <div class="rightSection flex-row flex__right">
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListChoTiepNhan(item)"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{ (item && item.vbDenChoTiepNhan) || 0 }}
              </span>
            </div>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListChoXyLy(item)"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{ (item && item.vbDenChoXuLy) || 0 }}
              </span>
            </div>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListChoBanHanh(item)"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{ (item && item.vbDiChoBanHanh) || 0 }}
              </span>
            </div>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListDaBanHanh(item)"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{ (item && item.vbDiDaBanHanh) || 0 }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </cardTemplate>
</template>


<script>
// import { EventBus } from "../../event-bus";
// import constants from "../../constants";
export default {
  name: "summaryCardVanThu",
  components: {
    cardTemplate: () => import("../common/cardTemplate.vue"),
  },
  props: ["dataVanThu"],
  methods: {
    viewListChoTiepNhan(item) {
      let userDeptRoleId = item.userDeptRoleView.id;
      this.$store.commit("changeUserDeptRole", userDeptRoleId);
      this.$router.push({
        name: "vbChoTiepNhan",
        params: { userDeptRoleId: userDeptRoleId },
      });
    },
    viewListChoXyLy(item) {
      let userDeptRoleId = item.userDeptRoleView.id;
      this.$store.commit("changeUserDeptRole", userDeptRoleId);
      this.$router.push({
        name: "vbDenChoXuLy",
        params: { userDeptRoleId: userDeptRoleId },
      });
    },
    viewListChoBanHanh(item) {
      let userDeptRoleId = item.userDeptRoleView.id;
      this.$store.commit("changeUserDeptRole", userDeptRoleId);
      this.$router.push({
        name: "vbChoBanHanh",
        params: { userDeptRoleId: userDeptRoleId },
      });
    },
    viewListDaBanHanh(item) {
      let userDeptRoleId = item.userDeptRoleView.id;
      this.$store.commit("changeUserDeptRole", userDeptRoleId);
      this.$router.push({
        name: "vbDaBanHanh",
        params: { userDeptRoleId: userDeptRoleId },
      });
    },
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/SummaryCardVanThu.vue